import { render, staticRenderFns } from "./KabMamberamoTengah.vue?vue&type=template&id=6d8a1d19"
import script from "./KabMamberamoTengah.vue?vue&type=script&lang=js"
export * from "./KabMamberamoTengah.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports